import { Injectable, signal, effect } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly KEY = 'ble_theme';

  isDark = signal(this.resolveInitial());

  constructor() {
    this.applyClass(this.isDark());
    effect(() => this.applyClass(this.isDark()));
  }

  toggle(): void {
    const next = !this.isDark();
    this.isDark.set(next);
    localStorage.setItem(this.KEY, next ? 'dark' : 'light');
  }

  private resolveInitial(): boolean {
    // Thème sombre par défaut ; ne bascule en clair que si l'utilisateur l'a
    // explicitement choisi (pas de suivi de la préférence système).
    return localStorage.getItem(this.KEY) !== 'light';
  }

  private applyClass(dark: boolean): void {
    document.body.classList.toggle('dark', dark);
  }
}
